export default "__VITE_ASSET__d56ef3b2__"